<template>
	<div>
		<v-card class="pa-md-4 ma-md-2" v-resize="myEventHandler">
			<v-row id="title" class="pa-2">
				
			<v-col cols="8" class="d-flex" md="12">
				<h1 class="font-weight-light">
					Terminales disponibles
				</h1>
			</v-col>
			<v-col cols="1" class="d-flex justify-end">
				<v-progress-circular
					class="ml-2"
					v-if="typing"
					width="2"
					:size="30"
					color="black"
					indeterminate
				></v-progress-circular>
			</v-col>
			

			<!-- Desk view-->
			<v-speed-dial
				v-if="!$vuetify.breakpoint.smAndDown"
				v-model="fab"
				absolute
				direction="left"
				class="pt-md-12"
				style="right: 45px; z-index: 1"
				transition="slide-x-transition"
			>
			<template v-slot:activator>
				<v-btn v-model="fab" class="mt-n12" icon>
					<h3 v-if="!fab" class="overline">Acciones</h3>
					<v-icon v-if="fab" large>mdi-close</v-icon>
					<v-icon v-else large>mdi-dots-vertical</v-icon>
				</v-btn>
			</template>
				<v-btn
					small
					v-if="hasSuperAdminPermission"
					color="success"
					@click="openDeviceCreate()"
				>
					<small>Crear Terminal</small>
					<v-icon right>mdi-toy-brick-plus-outline</v-icon>
					<v-icon right>mdi-form-select</v-icon>
				</v-btn>
				<v-btn
					small
					v-if="hasSuperAdminPermission"
					class="ml-1"
					dark
					color="yellow darken-3"
					@click="
					isOpenDownloadTemplateAndUpload = true;
					uploadMessage = 'subir el archivo con los terminales e installments';
					uploadAction = 'Subiendo';
					title = 'Creación de terminales Yoigo';
					templateMutationPath = '';
					submitPath = 'update_yoigo_tariffs_and_devices';
					uploadParam = 'CREATE'
					"
				>
					<small>Crear Terminales Yoigo</small>
					<v-icon right>mdi-toy-brick-plus-outline</v-icon>
					<v-icon right>mdi-microsoft-excel</v-icon>
				</v-btn>
				<v-tooltip bottom max-width="470px" color="grey darken-3">
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							small
							dark
							v-if="hasSuperAdminPermission"
							class="ml-1"
							color="pink darken-1"
							@click="
								isOpenDownloadTemplateAndUpload = true;
								uploadMessage = 'subir el archivo con los terminales e installments';
								uploadAction = 'Subiendo';
								title = 'Actualización de terminales Yoigo';
								templateMutationPath = '';
								submitPath = 'update_yoigo_tariffs_and_devices';
								uploadParam = 'UPDATE'
							"
							v-bind="attrs"
							v-on="on"
						>
							<small>Actualizar Terminales & Tarifas Yoigo</small>
							<v-icon right>mdi-update</v-icon>
							<v-icon right>mdi-microsoft-excel</v-icon>
						</v-btn>
					</template>
					<v-row>
						<v-col class="text-justify" cols="8">
							Este endpoint es de uso exclusivo para la <strong>actualización</strong> de los terminales 
							y tarifas de <strong>Yoigo</strong> como subproducto. De este modo, esta tarea desactivará 
							todos los terminales no incluidos en el archivo XLSX <v-icon dark>mdi-microsoft-excel</v-icon> 
							entre otros posibles efectos colaterales. Úsela con cautela.
						</v-col>
						<v-col cols="4" class="px-6 align-self-center">
							<v-icon size="90" color="orange">
								mdi-alert
							</v-icon>
						</v-col>
					</v-row>
				</v-tooltip>
				<v-tooltip bottom max-width="470px" color="grey darken-3">
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							small
							v-if="hasSuperAdminPermission"
							class="ml-1"
							dark
							color="deep-purple"
							@click="
								isOpenDownloadTemplateAndUpload = true;
								uploadMessage ='subir el archivo con los terminales e installments';
								uploadAction = 'Subiendo';
								title = 'Actualización de terminales MasMovil';
								templateMutationPath = '';
								submitPath = 'import_terminales_mm_xlsx';
							"
							v-bind="attrs"
							v-on="on"
						>
							<small>Actualizar Terminales MM</small>
							<v-icon right>mdi-update</v-icon>
							<v-icon right>mdi-microsoft-excel</v-icon>
						</v-btn>
					</template>
					<v-row>
						<v-col class="text-justify" cols="8">
							Este endpoint es de uso exclusivo para la <strong>actualización</strong> de los terminales 
							de <strong>MasMovil</strong>. De este modo, esta tarea desactivará todos los terminales no
							incluidos en el archivo XLSX <v-icon dark>mdi-microsoft-excel</v-icon> entre otros posibles
							efectos colaterales. Úsela con cautela.
						</v-col>
						<v-col cols="4" class="px-6 align-self-center">
							<v-icon size="90" color="orange">
								mdi-alert
							</v-icon>
						</v-col>
					</v-row>
				</v-tooltip>
			</v-speed-dial>
				

			<!--Mobile view-->
			<v-col
				v-if="$vuetify.breakpoint.smAndDown"
				cols="3">
				<v-speed-dial
					
					v-model="fab"
					absolute
					class="pa-10"
					direction="bottom"
					style="z-index: 100 !important;" 
					transition="slide-y-transition"
				>
				<template v-slot:activator>
					<v-btn v-model="fab" class="mt-n12" icon>
						<v-icon v-if="fab" large>mdi-close</v-icon>
						<v-icon v-else large>mdi-dots-vertical</v-icon>
					</v-btn>
				</template>
					<v-btn
						small
						v-if="hasSuperAdminPermission"
						color="success"
						@click="openDeviceCreate()"
					>
						
						<v-icon center>mdi-toy-brick-plus-outline</v-icon>
						<v-icon center>mdi-form-select</v-icon>
					</v-btn>
					<v-btn
						small
						v-if="hasSuperAdminPermission"
						class="ml-1"
						dark
						color="yellow darken-3"
						@click="
						isOpenDownloadTemplateAndUpload = true;
						uploadMessage = 'subir el archivo con los terminales e installments';
						uploadAction = 'Subiendo';
						title = 'Creación de terminales Yoigo';
						templateMutationPath = '';
						submitPath = 'update_yoigo_tariffs_and_devices';
						uploadParam = 'CREATE'
						"
					>
						
						<v-icon center>mdi-toy-brick-plus-outline</v-icon>
						<v-icon center>mdi-microsoft-excel</v-icon>
					</v-btn>
					<v-tooltip bottom max-width="470px" color="grey darken-3">
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								small
								dark
								v-if="hasSuperAdminPermission"
								class="ml-1"
								color="pink darken-1"
								@click="
									isOpenDownloadTemplateAndUpload = true;
									uploadMessage = 'subir el archivo con los terminales e installments';
									uploadAction = 'Subiendo';
									title = 'Actualización de terminales Yoigo';
									templateMutationPath = '';
									submitPath = 'update_yoigo_tariffs_and_devices';
									uploadParam = 'UPDATE'
								"
								v-bind="attrs"
								v-on="on"
							>
								
								<v-icon center>mdi-update</v-icon>
								<v-icon center>mdi-microsoft-excel</v-icon>
							</v-btn>
						</template>
						<v-row>
							<v-col class="text-justify" cols="8">
								Este endpoint es de uso exclusivo para la <strong>actualización</strong> de los terminales 
								y tarifas de <strong>Yoigo</strong> como subproducto. De este modo, esta tarea desactivará 
								todos los terminales no incluidos en el archivo XLSX <v-icon dark>mdi-microsoft-excel</v-icon> 
								entre otros posibles efectos colaterales. Úsela con cautela.
							</v-col>
							<v-col cols="4" class="px-6 align-self-center">
								<v-icon size="90" color="orange">
									mdi-alert
								</v-icon>
							</v-col>
						</v-row>
					</v-tooltip>
					<v-tooltip bottom max-width="470px" color="grey darken-3">
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								small
								v-if="hasSuperAdminPermission"
								class="ml-1"
								dark
								color="deep-purple"
								@click="
									isOpenDownloadTemplateAndUpload = true;
									uploadMessage ='subir el archivo con los terminales e installments';
									uploadAction = 'Subiendo';
									title = 'Actualización de terminales MasMovil';
									templateMutationPath = '';
									submitPath = 'import_terminales_mm_xlsx';
								"
								v-bind="attrs"
								v-on="on"
							>
								
								<v-icon center>mdi-update</v-icon>
								<v-icon center>mdi-microsoft-excel</v-icon>
							</v-btn>
						</template>
						<v-row>
							<v-col class="text-justify" cols="8">
								Este endpoint es de uso exclusivo para la <strong>actualización</strong> de los terminales 
								de <strong>MasMovil</strong>. De este modo, esta tarea desactivará todos los terminales no
								incluidos en el archivo XLSX <v-icon dark>mdi-microsoft-excel</v-icon> entre otros posibles
								efectos colaterales. Úsela con cautela.
							</v-col>
							<v-col cols="4" class="px-6 align-self-center">
								<v-icon size="90" color="orange">
									mdi-alert
								</v-icon>
							</v-col>
						</v-row>
					</v-tooltip>
				</v-speed-dial>
				</v-col>
			</v-row>
			<v-divider class="px-md-2"></v-divider>
			<v-data-table
				:loading="isLoadingDevices"
				:headers="headers"
				:items="devices"
				:footer-props="footer_props"
				:page.sync="page"
				:server-items-length="tableItemCount"
			>
				<template v-slot:item.IsActive="{ item }">
					<v-icon :color="item.is_active ? 'green' : 'red'">
						mdi-circle
					</v-icon>
				</template>
				<template v-slot:item.Actions="{ item }">
					<v-row>
						<v-col md="4">
							<v-btn
								class="d-flex grow justify-center flex-wrap"
								fab
								small
								color="primary"
								outlined
								@click="openDeviceInfo(item)"
							>
								<v-icon> mdi-information-slab-box </v-icon>
							</v-btn>
						</v-col>
						<v-col v-if="hasSuperAdminPermission" md="4">
							<v-btn
								class="d-flex grow justify-center flex-wrap"
								fab
								small
								color="orange"
								outlined
								@click="openDeviceEdit(item)"
							>
								<v-icon> mdi-pen </v-icon>
							</v-btn>
						</v-col>
						<v-col v-if="hasSuperAdminPermission" md="4">
							<v-btn
								class="d-flex grow justify-center flex-wrap"
								fab
								small
								color="red"
								outlined
								@click="openDeviceDelete(item)"
							>
								<v-icon> mdi-delete-empty-outline </v-icon>
							</v-btn>
						</v-col>
					</v-row>
				</template>
			</v-data-table>
		</v-card>
		<div id="fullHeigth"></div>
		<DeviceInfo />
		<DeviceDelete />
		<DeviceEdit />
		<DownloadTemplateAndUpload
			:message="uploadMessage"
			:multiple="false"
			:datePicker="false"
			:title="title"
			:templateMutationPath="templateMutationPath"
			submitMutationPath="gerencia/importFiles"
			:submitPath="submitPath"
			:uploadParam="uploadParam"
		/>
	</div>
</template>

<script>
import DeviceInfo from '@/components/ComercialTeletrabajo/DeviceManagement/DeviceInfo.vue';
import DeviceDelete from '@/components/ComercialTeletrabajo/DeviceManagement/DeviceDelete.vue';
import DeviceEdit from '@/components/ComercialTeletrabajo/DeviceManagement/DeviceEdit.vue';
import DownloadTemplateAndUpload from '@/components/DownloadTemplateAndUpload/DownloadTemplateAndUpload.vue';
import { mapState, mapGetters } from 'vuex';
import defaultDeviceForm from '@/util/management/defaultDeviceForm.js';
import { clone } from '@/util/libUtil.js';

export default {
	name: 'DevicefManagementTable',
	components: {
		DownloadTemplateAndUpload,
		DeviceInfo,
		DeviceEdit,
		DeviceDelete,
	},
	data: () => ({
		fab: false,

		typing: false,
		lastTypeTime: null,

		uploadMessage: '',
		title: '',
		templateMutationPath: '',
		submitPath: '',
		uploadParam: 'CREATE',

		page: 1,
		footer_props: {
			disableItemsPerPage: true,
			itemsPerPageOptions: [13],
		},
		// search: '',
		headers: [
			{ text: 'Marca', value: 'brand', sortable: false },
			{ text: 'Modelo', value: 'name', sortable: false },
			{ text: 'Operador', value: 'operator', sortable: false },
			{ text: 'Activo', value: 'IsActive', sortable: false },
			{
				text: 'Acciones',
				value: 'Actions',
				sortable: false,
				width: '200px',
			},
		],
	}),
	computed: {
		...mapGetters('login', {
			hasManagerPermission: 'hasManagerPermission',
			hasSuperAdminPermission: 'hasSuperAdminPermission',
		}),
		isOpenDownloadTemplateAndUpload: {
			get() {
				return this.$store.state.util.isOpenDownloadTemplateAndUpload;
			},
			set(val) {
				this.$store.commit('util/isOpenDownloadTemplateAndUpload', val);
			},
		},
		selectedDevice: {
			get() {
				return this.$store.state.deviceManagement.selectedDevice;
			},
			set(val) {
				this.$store.commit('deviceManagement/selectedDevice', val);
			},
		},
		isOpenDialog: {
			get() {
				return this.$store.state.deviceManagement.isOpenDialog;
			},
			set(val) {
				// this.$store.commit('deviceManagement/selectedDevice', null);
				this.$store.commit('deviceManagement/isOpenDialog', val);
			},
		},
		...mapState('deviceManagement', {
			tableItemCount: (state) => state.tableItemCount,
			devices: (state) => state.devices,
			isLoadingDevices: (state) => state.isLoadingDevices,
		}),
		...mapState('util', {
			search: (state) => state.navBarSearchField,
		}),
	},
	methods: {
        openDeviceCreate() {
            this.$store.commit('deviceManagement/deviceEditFormType', 'CREATE');
            this.$store.commit(
                'deviceManagement/editingDevice',
                clone(defaultDeviceForm)
            );
            this.$store.commit('deviceManagement/isOpenEditDialog', true);
        },
		openDeviceInfo(item) {
			this.$store.dispatch('deviceManagement/getRelatedTariffs', item);
			this.$store.commit('deviceManagement/selectedDevice', item);
			this.$store.commit('deviceManagement/isOpenDialog', true);
		},
		openDeviceEdit(item) {
			let deviceObj = clone(defaultDeviceForm);

			for (let key in deviceObj) {
				if (key in item) {
					deviceObj[key] = item[key];
				}
			}

			this.$store.dispatch('deviceManagement/getRelatedTariffs', item);
			this.$store.commit('deviceManagement/deviceEditFormType', 'EDIT');
			this.$store.commit(
				'deviceManagement/editingDevice',
				clone(deviceObj)
			);
			this.$store.commit('deviceManagement/isOpenEditDialog', true);
		},
		openDeviceDelete(item) {
			let deleteObj = {
				toDeleteId: item.id,
				toDeleteType: 'DEVICE',
				isOpenDeleteDialog: true,
			};
            this.$store.commit('deviceManagement/deviceEditFormType', 'EDIT');
            this.$store.dispatch('deviceManagement/getRelatedTariffs', item);
            this.$store.commit(
                'deviceManagement/editingDevice',
                clone(deviceObj)
            );
            this.$store.commit('deviceManagement/isOpenEditDialog', true);
        },
        openDeviceDelete(item) {
            let deleteObj = {
                toDeleteId: item.id,
                toDeleteType: 'DEVICE',
                isOpenDeleteDialog: true,
            };

			this.$store.commit(
				'deviceManagement/deleteObject',
				clone(deleteObj)
			);
		},
		myEventHandler() {
			let fullHeight = document.getElementById('fullHeigth').offsetHeight;
			let navBar = document.getElementById('navBar').offsetHeight;
			let title = document.getElementById('title').offsetHeight;
			let adjustment = 100;
			let numRows = parseInt(
				parseInt(fullHeight - navBar - title - adjustment) / 47
			);

			let params = {
				itemsPerPage: numRows,
				page: this.page,
				is_active: 1,
			};

			if (numRows != this.footer_props['itemsPerPageOptions'][0])
				this.$store.dispatch('deviceManagement/getDevices', params);

			this.footer_props['itemsPerPageOptions'].pop();
			this.footer_props['itemsPerPageOptions'].push(numRows);
		},
		getNumItems() {
			let fullHeight = document.getElementById('fullHeigth').offsetHeight;
			let navBar = document.getElementById('navBar').offsetHeight;
			let title = document.getElementById('title').offsetHeight;
			let adjustment = 100;
			let numRows = parseInt(
				parseInt(fullHeight - navBar - title - adjustment) / 47
			);
			return numRows;
		},
		getItems(val) {
			let params = {
				page: 1,
				search: val,
				itemsPerPage: this.getNumItems(),
				is_active: 1,
			};
			let storeRoute = 'deviceManagement/getDevices';

			this.typing = false;
			if (!params['search']) delete params['search'];

			this.$store.dispatch(storeRoute, params);
		},
		checkTimeout(val) {
			let difference = new Date().getTime() - this.lastTypeTime;

			// Si no escribimos en un segundo se hará una petición para buscar el elemento en BD
			setTimeout(() => {
				if (difference > 1000) {
					if (val.length == this.search.length) {
						this.page = 1;
						this.getItems(val);
					}
				} else this.checkTimeout(val);
			}, 500);
		},
	},
	watch: {
		page() {
			let params = {
				itemsPerPage: this.footer_props['itemsPerPageOptions'][0],
				page: this.page,
				search: this.search,
				is_active: 1,
			};

			this.$store.dispatch('deviceManagement/getDevices', params);
		},
		search(val) {
			if (this.search) this.typing = true;
			else this.typing = false;

			this.lastTypeTime = new Date().getTime();
			this.checkTimeout(val);
		},
	},
	updated() {
		this.myEventHandler();
	},
	beforeCreate() {
		// this.$store.dispatch('deviceManagement/getDevicesDropDown')
		this.$store.dispatch('deviceManagement/getInsurances');
	},
};
</script>

<style>
#fullHeigth {
	height: 100vh;
	width: 0;
	position: absolute;
}
</style>